<template>
  <div class="pkg-preview">
    <pkg-dialog
      :visible.sync="visible"
      :cur-selected-data="curSelectedData"
      :interval-task-info="intervalTaskInfo.bind(this)"
      :file-list.sync="fileList"
      @preview="preview"
      @changePkgId="(data) => { pkgId = data }"
      @showTips="showTips"
      @close="close"
      @goUnpack="isUnpack = true"
      @changeAllPkgData="(data) => { allPkgData = data }"
      @changeParentData="(data) => { parentData = data }"
      @changeCompsShowStatus="changeCompsShowStatus"
      @closePreviewPkg="close"
    />
    <file-unpack
      v-if="isUnpack"
      ref="fileUnpack"
      :is-unpack.sync="isUnpack"
      :parent-data="parentData"
      :path="currentPath"
      :pkg-data="curSelectedData"
      :all-pkg-data="allPkgData"
      :check-pwd-info.sync="checkPwdInfo"
      :password="password"
      @download="download"
      @showTips="showTips"
      @extract="extract"
      @downloadClient="downloadClient = true"
      @clearPassword="() => { password = '' }"
    />
    <progress-unpack v-if="isUnpackProgress" />
    <pkg-password
      v-if="showPasswordDialog"
      ref="pkgPassword"
      :show-password-dialog.sync="showPasswordDialog"
      :pkg-dialog-visible="visible"
      :check-pwd-info.sync="checkPwdInfo"
      @confirmPkg="confirmPkg"
      @clearPassword="() => { password = '' }"
      @closePkgPreview="close"
    />
    <div
      v-show="taskFailed"
      ref="taskFailed"
      class="complete-extract failed"
    >
      <span class="task-failed">{{ $t('解压失败！') }}</span>
      <span class="task-failed-contend">{{
        $t('可能由于服务器或压缩包内文件的问题，稍后再试')
      }}</span>
      <span
        class="complete-complete-close"
        @click="closeTaskFailed"
      />
    </div>
    <progress-custom
      v-if="isProgress"
      :progress-data="progressData"
      @closeProgress="closeProgress"
    />
    <co-dialog
      :visible.sync="showIeTip"
      :title="this.$t('提示')"
      @close="close"
    >
      <div class="ieTip">
        <p>{{ $t('抱歉，请检查您的浏览器设置。') }}</p>
        <p class="ieTip-content">
          {{
            $t(
              // eslint-disable-next-line max-len
              '设置方法：打开您的浏览器Internet选项，切换到“安全”选项页，选中Internet区域，单击“自定义级别”按钮，在弹出的对话框中找到“其他”类别下的“通过域访问数据资源”，将其选择为“启用”状态。点击确定保存。',
            )
          }}
        </p>
        <p>{{ $t('设置完成后，请刷新本页面重试。') }}</p>
      </div>
    </co-dialog>
    <co-confirm
      id="download-client-confirm"
      v-model="downloadClient"
      :title="this.$t('提示')"
      :content="this.$t('网页目前仅支持单文件解压到本地')"
      :describe="this.$t('您可以在客户端进行该操作')"
      :is-describe="true"
      :sure-btn="this.$t('下载客户端')"
      @sure="downloadClientDialog"
    />
    <co-confirm
      id="different-password-confirm"
      v-model="differentPassword"
      :title="this.$t('提示')"
      :content="this.$t('压缩包中的文件设置了不同的密码，请将压缩包下载本地进行访问')"
      :is-describe="true"
      :sure-btn="this.$t('知道了')"
      @close="differentPwdConfirm"
      @sure="differentPwdConfirm"
    />
  </div>
</template>

<script>
/* eslint-disable camelcase */
import store from 'store'
import _$ from 'js/api/getdata'
import * as Util from 'js/util/util'
import coDialog from 'components/common/dialog/index.vue'
import coConfirm from 'components/common/confirm/index.vue'
import { EventBus } from 'js/util/event-bus'
import { linkFileDownload as js2NativelinkFileDownload, openUrlInside, openUrlOutside } from '@filez/js-2-native'
import pkgDialog from './pkg-dialog.vue'
import FileUnpack from '../../../../common/pkg-unpack/file-unpack.vue'
import ProgressCustom from '../../../../common/pkg-progress/progress-custom.vue'
import ProgressUnpack from '../../../../common/pkg-progress/progress-unpack.vue'
import PkgPassword from '../../../../common/pkg-password/pkg-password.vue'

export default {
  components: {
    coDialog,
    FileUnpack,
    coConfirm,
    pkgDialog,
    ProgressCustom,
    ProgressUnpack,
    PkgPassword,
  },
  props: {
    curSelectedData: {
      type: Object,
      default() {
        return {}
      },
    },
    isShowPreviewPkg: {
      type: Boolean,
      deafult: false,
    },
    currentList: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
      sort: '',
      order_by: '',
      limit: 50,
      offset: 0,
      totalSize: 0,
      taskFailed: false,
      renderFinished: false, // 数据接口返回结束标识
      rootUrl: '', // 回到首页
      currentUrl: '', // 加载更多用
      parentPath: '', // 面包屑路径
      parentData: {}, // 父级数据
      fileList: [],
      allPkgData: [],
      metaUrlCrumb: [], // 面包屑url
      isUnpack: false, // 解压
      isProgress: false, // 进度条
      isUnpackProgress: false,
      timer: null, // 轮询检查任务
      unpackTimer: null, // 轮询检查任务
      isChooseDir: false,
      isExtract: false, // 是否显示解压到按钮
      isCreate: false,
      showPasswordDialog: false,
      loading: null,
      isLoading: false, // 1s后loading
      pkgNodeData: {},
      showIeTip: false,
      complete: false, // 防止客户端多次调用
      correctPwd: '', // 压缩包正确的密码
      progressData: {
        // 进度条
        txt: '',
        firstExtract: '',
      },
      extractDirData: {
        // 跳转目录数据
        isCurrentPath: true, // 是否当前目录
        pathType: '',
        neid: '',
      },
      extractFilePathDirData: {
        path: '',
        path_type: '',
        prefix_neid: '',
      },
      isChoosePath: false, // 是否选择其他目录
      visible: false,
      dialogStyle: {
        width: '680px',
      },
      choosePkgDirModalControls: {
        isClose: false,
        selectedData: {},
        currentPathData: {},
      },
      downloadClient: false,
      differentPassword: false,
      pkgId: '',
      password: '',
      pkgDownloadInfo: '',
      checkPwdInfo: '',
      PKG_FINISHED: 0,
      PKG_PROCESSING: 1,
      pkgInfo: '',
    }
  },
  computed: {
    isEncrypted() {
      // 是否加密
      return this.parentData.is_encrypted
    },
    pathType() {
      const { $route } = this
      return $route.meta.path_type || $route.name
    },
    currentPath() {
      if (this.pathType === 'recent' || this.pathType === 'favorite') {
        return '/'
      }
      return this.currentList.path
    },
    neid() {
      return this.curSelectedData.neid
    },
    nsid() {
      return this.curSelectedData.nsid
    },
    path_type() {
      return this.curSelectedData.path_type
    },
    access_mode() {
      return this.curSelectedData.access_mode
    },
    data() {
      return this.curSelectedData.data
    },
    rootName() {
      const path = this.curSelectedData.path.split('/').pop()
      return path.slice(0, path.lastIndexOf('.'))
    },
    pkgTitle() {
      return this.curSelectedData.path ? this.curSelectedData.path.split('/').pop() : ''
    },
    crumbList() {
      // 面包屑路径
      const paths = this.parentPath.slice(1, this.parentPath.length - 1).split('/')
      return paths[0] === '' ? [this.rootName] : [this.rootName, ...paths]
    },
    toUnpack() {
      const len = store.getters.pkgSelectedLength
      if (len < 1) {
        return this.$t('全部解压到')
      }
      return this.$t('解压到')
    },
    selectedData() {
      const data = store.state.pkgSelectedData.data.map((d) => d.data)
      const len = store.getters.pkgSelectedLength
      if (len === 0) return {}
      return data
    },
  },
  created() {
    store.commit('clearPkgData')
  },
  mounted() {
    this.extractDirData.isCurrentPath = true
  },
  destroyed() {
    clearInterval(this.timer)
    this.timer = null
    if (Util.isClient()) {
      const WndName = 'MainWndTitle'
      const Operate = 'show'
      Util.controlClientWnd(Operate, WndName)
    }
  },
  methods: {
    downloadClientDialog() {
      EventBus.$emit('downloadClientDialog', 123)
      this.isUnpack = false
    },
    differentPwdConfirm() {
      this.$emit('closePreviewPkg')
    },
    // 轮询查看任务状态
    async intervalTaskInfo({ taskId, cb, type }) {
      const getTaskInfo = async () => {
        const res = await _$.getData(`/v2/pkg/task/info/${taskId}`).catch((err) => err.response)
        if (res.status === 412) {
          this.isProgress = false
          this.isUnpackProgress = false
          this.differentPassword = true
          clearInterval(this.taskTimer)
          return
        }
        if (res.status === 409) {
          clearInterval(this.taskTimer)
          if (type === 'extract') {
            this.isUnpackProgress = false
          } else {
            this.isProgress = false
          }
          if (sessionStorage.getItem('correctPassword')) {
            this.differentPassword = true
          } else {
            if (this.$refs.pkgPassword) {
              this.$refs.pkgPassword.reset()
            }
            if (this.$refs.fileUnpack && this.$refs.fileUnpack.$refs.pkgPassword) {
              this.$refs.fileUnpack.$refs.pkgPassword.reset()
            }
            this.checkPwdInfo = res.data.message
          }
          return
        }
        if (res.status !== 200) {
          this.showTips({
            message: res.data.message,
            type: 'error',
          })
          clearInterval(this.taskTimer)
          if (type === 'openPkgDialog') {
            this.$emit('closePreviewPkg')
          } else {
            this.isProgress = false
            this.isUnpackProgress = false
          }
          return
        }
        const { data } = res
        if (data.status === this.PKG_FINISHED) {
          if (type === 'extract') {
            this.isUnpackProgress = false
          } else {
            this.isProgress = false
          }
          clearInterval(this.taskTimer)
          cb({ taskId })
        }
      }
      this.taskTimer = setInterval(() => {
        getTaskInfo()
      }, 1000)
    },
    changeCompsShowStatus(compsShowStatusObj) {
      Object.keys(compsShowStatusObj).forEach((key) => {
        if (key === 'firstExtract') {
          this.progressData.firstExtract = compsShowStatusObj[key]
          return
        }
        this[key] = compsShowStatusObj[key]
      })
    },
    async extractDir(nodeData) {
      this.pkgNodeData = nodeData
      if (this.isEncrypted) {
        this.actionType = 'extract'
        this.showPasswordDialog = true
        return
      }
      this.confirmExtract()
    },
    confirmExtract(val) {
      const nodeData = this.pkgNodeData
      let passWord = ''
      let pathArr
      let extractUrl
      const extractNeid = nodeData.neid
      const pathType = nodeData.path_type
      const { prefix_neid } = nodeData
      if (store.getters.pkgSelectedLength > 0) {
        pathArr = this.selectedData.map((d) => d.path)
        extractUrl = this.selectedData[0].extract_url
      } else {
        pathArr = '/'
        extractUrl = this.fileList[0].extract_url
      }
      if (val) {
        passWord = val
      }
      this.extractDirData.isCurrentPath = false
      this.extractDirData.pathType = pathType
      this.extractDirData.neid = extractNeid
      this.extract({
        extractUrl, pathArr, extractNeid, pathType, prefix_neid, passWord,
      })
    },
    confirmPkg(val) {
      if (this.actionType === 'openPkgDialog') {
        this.openPkgDialog()
      }
      if (this.actionType === 'preview') {
        this.getPreviewData({ password: `${this.$jsEncrypt.encrypt(val)}` })
      }
    },
    closeProgress() {
      this.isProgress = false
      this.close({ status: 'cancel' })
    },
    closeTaskFailed() {
      this.taskFailed = false
      this.close({ status: 'cancel' })
    },
    showTips({ message, type }) {
      this.$emit('showTips', message, type)
    },
    clearConfirmData() {
      const cda = {
        title: '',
        content: '',
        cb() {},
      }
      Object.assign(this.confirmData.props, cda)
    },
    decorateUrl(url, dePath) {
      let uri = url
      const lan = Util.getLanguage()
      if (dePath && uri.indexOf('paths') !== -1) {
        const pathIndex = uri.indexOf('paths')
        let endIndex = uri.indexOf('&', pathIndex)
        if (endIndex === -1) {
          endIndex = uri.length
        }
        const pathStr = uri.slice(pathIndex - 1, endIndex)
        uri = uri.replace(pathStr, '')
      }
      if (uri.indexOf('language') !== -1) {
        const pathIndex = uri.indexOf('language')
        let endIndex = uri.indexOf('&', pathIndex)
        if (endIndex === -1) {
          endIndex = uri.length
        }
        const pathStr = uri.slice(pathIndex - 1, endIndex)
        uri = uri.replace(pathStr, `&language=${lan}`)
      }
      return uri
    },
    close({ status = null } = {}) {
      this.showPasswordDialog = false
      this.isChooseDir = false
      this.choosePkgDirModalControls.isClose = true
      this.isUnpack = false
      this.isProgress = false
      this.parentPath = ''
      this.correctPwd = ''
      if (status === 'cancel') {
        this.visible = false
      }
      this.$emit('closePreviewPkg')
    },
    // 获取解压服务路由地址，用户操作权限校验等
    // 预览，只支持文档类型
    preview() {
      if (this.isEncrypted && !this.password) {
        this.actionType = 'preview'
        this.showPasswordDialog = true
        return
      }
      this.getPreviewData()
    },
    getPreviewData(data) {
      this.pkgInfo = data
      this.confirmPreview()
    },
    async confirmPreview(data) {
      const params = {
        neid: this.neid,
        nsid: this.nsid,
        path_type: this.path_type,
        entry_id: store.getters.pkgLastSelectedData.data.entry_id,
        pkg_id: this.pkgId,
        password: this.password || (this.pkgInfo && this.pkgInfo.password),
      }
      if (this.pathType === 'share_in') {
        params.from = this.from
        params.prefix_neid = this.prefixNeid
      }
      if (data && data.task_id) {
        params.task_id = data.task_id
      }
      const res = await _$.postData('pkgPreview', params).catch((err) => err.response)
      if (res.data.state === 409) {
        if (this.password) {
          this.differentPassword = true
        } else {
          this.$refs.pkgPassword.reset()
          this.checkPwdInfo = res.data.message
        }
        return
      }
      if (res.status !== 200) {
        this.showTips({
          message: res.data.message,
          type: 'error',
        })
        return
      }
      if (res.data.status === this.PKG_PROCESSING) {
        this.previewTaskId = res.task_id
        this.progressData.firstExtract = false
        this.progressData.txt = this.$t('文件正在提取中，即将打开...')
        this.isProgress = true
        this.intervalTaskInfo({
          taskId: res.data.task_id, cb: this.confirmPreview, type: this.actionType,
        })
      } else if (res.data.status === this.PKG_FINISHED) {
        if (this.pkgInfo && this.pkgInfo.password) {
          this.password = this.pkgInfo.password
          this.showPasswordDialog = false
        }
        const previewParams = {}
        const preUrl = encodeURIComponent(res.data.stat_url)
        const mimeType = store.getters.pkgLastSelectedData.data.mime_type
        const path = encodeURIComponent(store.getters.pkgLastSelectedData.data.path)
        previewParams.url = `${window.location.protocol}//${window.location.host}/js/module/preview/newPreview.html?preUrl=${preUrl}&mime_type=${mimeType}&path=${path}&isPreviewUrl=true`
        if (Util.isClient()) {
          previewParams.width = '800'
          previewParams.height = '600'
          previewParams.fullscreen = 'false'
          previewParams.loadingStyle = 'carousel'
          previewParams.path_type = this.pathType
          const reg = /(dwg|video|audio)/
          if (reg.test(mimeType)) {
            openUrlOutside(previewParams)
          } else {
            openUrlInside(previewParams)
          }
          return
        }
        window.open(previewParams.url, '_blank')
      }
    },
    // 下载
    download(data) {
      this.pkgInfo = data
      this.confirmDownload()
    },
    async confirmDownload(data) {
      const params = {
        neid: this.neid,
        nsid: this.nsid,
        pkg_id: this.pkgId,
        path_type: this.pathType,
        entry_id: this.pkgInfo.entryId,
        is_ie: Util.isIE(),
      }
      if (this.pathType === 'share_in') {
        params.from = this.from
        params.prefix_neid = this.prefixNeid
      }
      if (this.pkgInfo.password) {
        params.password = this.pkgInfo.password
      }
      if (data && data.taskId) {
        params.task_id = data.taskId
      }
      const res = await _$.postData('pkgDownload', params).catch((err) => err.response)
      if (res.data.state === 412) {
        this.differentPassword = true
        return
      }
      if (res.data.state === 409) {
        if (this.password) {
          this.differentPassword = true
        } else {
          this.$refs.fileUnpack.$refs.pkgPassword.reset()
          this.checkPwdInfo = res.data.message
        }
        return
      }
      if (res.status !== 200) {
        this.showTips({
          message: res.data.message,
          type: 'error',
        })
        return
      }
      if (res.data.status === this.PKG_PROCESSING) {
        this.downloadTaskId = res.task_id
        this.progressData.firstExtract = false
        this.progressData.txt = this.$t('正在从压缩包提取文件，即将开始下载')
        this.isProgress = true
        this.intervalTaskInfo({
          taskId: res.data.task_id, cb: this.confirmDownload, type: this.actionType,
        })
      } else if (res.data.status === this.PKG_FINISHED) {
        if (params.password) {
          this.password = params.password
        }
        this.isUnpack = false
        if (Util.isClient()) {
          let len
          if (store.getters.pkgSelectedLength > 0) {
            len = store.getters.pkgSelectedLength
          } else {
            len = this.allPkgData.length
          }
          const times = Math.ceil(len / 100) // times-每一百个数据调一次客户端下载接口
          for (let i = 0; i < times; i += 1) {
            const hasMore = i !== times - 1 // 标识是否最后一批数据
            this.clientDownLoad(i, hasMore, this.pkgInfo.password)
          }
        } else {
          window.location.href = res.data.dlInfo[0].dl_url
        }
      }
    },
    // 解压
    extract(data) {
      const vm = this
      const uri = vm.decorateUrl(data.extractUrl, true)
      const params = {
        paths: data.pathArr,
        path_type: data.pathType,
        repeat: true,
      }
      if (data.passWord !== '') {
        params.password = data.passWord
      }
      if (data.prefix_neid) {
        params.prefix_neid = data.prefix_neid
      }
      if (
        (vm.pathType === 'recent' || vm.pathType === 'favorite')
        && this.extractDirData.isCurrentPath
      ) {
        // 我的收藏和最近访问获取压缩包所在目录
        const DEFAULT = {
          path_type: vm.curSelectedData.path_type, // 数据的type
          include_deleted: false,
          url: vm.curSelectedData.path.substring(0, vm.curSelectedData.path.lastIndexOf('/')) || '/',
          prefix_neid: vm.curSelectedData.prefix_neid || '',
          nsid: vm.curSelectedData.nsid,
        }
        const newParams = { ...DEFAULT }
        _$.getData('getMetadata', newParams).then((res) => {
          vm.extractFilePathDirData.path = res.data.path
          vm.extractFilePathDirData.path_type = res.data.path_type
          vm.extractFilePathDirData.prefix_neid = res.data.prefix_neid
          this.extractDirData.neid = res.data.neid
          this.extractDirData.isCurrentPath = false
          this.extractDirData.pathType = res.data.path_type
          params.neid = res.data.neid
          params.prefix_neid = res.data.prefix_neid ? res.data.prefix_neid : ''
          vm.secExtract(uri, params)
        })
      } else if (data.extractNeid) {
        params.neid = data.extractNeid
        vm.isChoosePath = true
        vm.secExtract(uri, params)
      } else {
        // 在压缩包所在路径下解压到压缩包所在目录
        vm.extractFilePathDirData.path = vm.currentList.path
        vm.extractFilePathDirData.path_type = vm.currentList.path_type
        vm.extractFilePathDirData.prefix_neid = vm.currentList.prefix_neid
        params.neid = vm.currentList.neid // 当前目录
        vm.secExtract(uri, params)
      }
    },
    async secExtract(data, taskId) {
      const params = {
        pkg_id: this.pkgId,
        neid: data.neid,
        nsid: data.nsid,
        password: data.password,
        path_type: data.path_type,
        paths: data.path,
        prefix_neid: data.prefix_neid,
        from: this.from,
      }
      if (taskId) {
        params.task_id = taskId
      }
      const res = await _$.postData('pkgExtract', params).catch((err) => err.response)
      if (res.data.state === 412) {
        this.differentPassword = true
        return
      }
      if (res.data.state === 409) {
        if (sessionStorage.getItem('correctPassword')) {
          this.differentPassword = true
        } else {
          if (this.$refs.pkgPassword) {
            this.$refs.pkgPassword.reset()
          }
          if (this.$refs.fileUnpack && this.$refs.fileUnpack.$refs.pkgPassword) {
            this.$refs.fileUnpack.$refs.pkgPassword.reset()
          }
          this.checkPwdInfo = res.data.message
        }
        return
      }
      if (res.status !== 200) {
        this.showTips({
          message: res.data.message,
          type: 'error',
        })
        return
      }
      if (res.status === 200) {
        this.visible = false
        this.isUnpack = false
        this.isChooseDir = false
        this.isPassword = false
      }
      if (res.data.status === this.PKG_PROCESSING) {
        this.extractTaskId = res.task_id
        this.isUnpackProgress = true
        this.intervalTaskInfo({
          taskId: res.data.task_id, cb: this.extract, type: this.actionType,
        })
      } else if (res.data.status === this.PKG_FINISHED) {
        this.failedSize = res.data.failed_size
        this.successSize = res.data.success_size
        if (data.password) {
          this.password = data.password
          this.isPassword = false
        }
        this.completeExtract = true
        this.extractPath = res.data.extract_path
      }
    },
    clientDownLoad(times, hasMore) {
      let len
      let data
      if (store.getters.pkgSelectedLength > 0) {
        len = store.getters.pkgSelectedLength
        data = this.selectedData
      } else {
        len = this.allPkgData.length
        data = this.allPkgData
      }
      const dlArr = []
      const startIndex = times * 100
      const endIndex = startIndex + 100 <= len ? startIndex + 100 : len
      for (let i = startIndex; i < endIndex; i += 1) {
        const dlObj = {}
        dlObj.path = data[i].path
        dlObj.size = data[i].bytes
        dlObj.isdir = data[i].isDir
        dlObj.download_url = data[i].dl_url
        dlObj.password = this.correctPwd
        if (data[i].isDir) {
          dlObj.meta_url = data[i].meta_url
        }
        dlArr.push(dlObj)
      }
      if (Util.isLinux()) {
        js2NativelinkFileDownload({ FileEntries: dlArr, has_more: hasMore })
      } else {
        jsToNative('LinkFileDownload', JSON.stringify({ FileEntries: dlArr, has_more: hasMore }))
      }
    },
    /**
     * 获取metaUrl
     * * */
    getMetaUrl(index, path) {
      if (index === 0) {
        this.parentPath = ''
        return this.rootUrl
      }
      this.parentPath = `${path.replace(new RegExp(this.rootName), '')}/`
      // 其他目录根据metaUrl 取值
      const urlIndex = index - 1
      this.metaUrlCrumb.splice(urlIndex + 1, this.metaUrlCrumb.length - urlIndex - 1)
      return this.metaUrlCrumb[urlIndex]
    },
  },
}
</script>

<style>
.pkg-no-file {
   display: flex;
   justify-content: center;
   align-items: center;
   height: calc(100% - 33px - 24px);
   color: green;
 }
.pkg-no-file .pkg-empty-title {
  margin-top: -15px;
  font-size: 14px;
  color: #237bf8;
  text-align: center;
}
#download-client-confirm {
  z-index: 99;
}
#different-password-confirm {
  z-index: 99;
}
</style>
<style lang="less" scoped>
.complete-extract {
  position: fixed;
  top: 20px;
  left: 50%;
  z-index: 999;
  box-sizing: border-box;
  min-width: 250px;
  height: 36px;
  padding-right: 24px;
  padding-left: 24px;
  line-height: 36px;
  text-align: center;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
  transform: translateX(-50%);
  &.failed {
    padding-right: 48px;
    padding-left: 48px;
  }
  span {
    display: inline-block;
  }
  .complete-complete-view {
    color: #0a64fa;
    cursor: pointer;
  }
  .complete-complete-close {
    position: absolute;
    top: 8px;
    right: 12px;
    float: right;
    width: 20px;
    height: 20px;
    cursor: pointer;
    background-image: url(~image/close.svg);
    background-repeat: no-repeat;
    background-position: right;
  }
  .task-failed {
    color: red;
  }
}
.pkg-fade-enter-active {
  animation: pkg-fade-in 0.3s;
}

.pkg-fade-leave-active {
  animation: pkg-fade-out 0.3s;
}

@keyframes pkg-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes pkg-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ieTip {
  width: 500px;
  padding: 20px;
  .ieTip-content {
    margin: 5px 0 5px 0;
  }
}
</style>
